import DocumentWithPreviewImage from "Areas/Documents/documentWithPreviewImage";
import Scrollbars from "Components/scrollbars";
import WelcomePanel from "Components/welcomePanel";
import map from "lodash/map";
import React from "react";
import locale from "./documentList.locale";
export default function DocumentList(props) {
    var _a;
    return (React.createElement("div", { className: "h-100 grid-rows-auto-1fr" }, ((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) === 0 ? (React.createElement(WelcomePanel, { messageClassName: "font-base", showIcon: false, message: locale.NO_DATA_TEXT })) : (React.createElement(Scrollbars, null,
        React.createElement("div", { className: "d-flex self-start flex-wrap with-gap-sm" }, map(props.data, document => (React.createElement(DocumentWithPreviewImage, { key: document.Id, document: document }))))))));
}
